/**
 * Re-export shim — the defensive Enin bundle extraction helpers moved to
 * @repo/shared/types (QP-184) so the API's AML screening derives the same
 * owners/roles the widget displays.
 */

export {
  currencyForCompanyId,
  type EninCompanyDetails,
  type EninFinancials,
  type EninOwner,
  type EninRole,
  extractCompanyDetails,
  extractFinancials,
  extractOwners,
  extractRoles,
} from "@repo/shared/types";
